import { TConfig, TConfigInput, TConfigParams } from '@@/auto/interfaces';

import { featureFlags } from '../../featureFlags';

function ToyotaCAConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlags.CA_EXPANSION_CODE)
    ? {
        auto: (auto: TConfig['auto']) => {
          return {
            ...auto,
            addOns: {
              ...auto.addOns,
              alwaysOnOptions: {
                ...auto.addOns.alwaysOnOptions,
                roadside_assistance: {
                  ...auto.addOns.alwaysOnOptions?.roadside_assistance,
                  copy: {
                    ...auto.addOns.alwaysOnOptions?.roadside_assistance.copy,
                    textAlert:
                      'Lucky for you this Add On is always on with your Toyota Coverage!',
                  },
                },
              },
            },
          };
        },
        alwaysOnConfig: {
          selfServiceConfig: {
            subHeader:
              'These additional perks are included with every Toyota auto policy.',
          },
          quoteFlowConfig: {
            subHeader:
              'These additional perks are included with every Toyota auto policy.',
          },
        },
      }
    : {};
}
export default ToyotaCAConfig;
